import Vue from 'vue'
import uiToast from './uiToast.vue'

const VueComponent = Vue.extend(uiToast)
const vm = new VueComponent().$mount()
let init = false
let defaultOptions = {}

const toast = function (options) {
  Object.assign(vm, defaultOptions, options, {
    type: 'toast'
  })

  if (!init) {
    document.body.appendChild(vm.$el)
    init = true
  }
  return vm.toast()
}

export default toast


// WEBPACK FOOTER //
// ./src/component/uiToast/index.js